/**
 * App Logo Component
 * 
 * Clean iOS-style brand header with:
 * - Forget Me Not flower icon (transparent background)
 * - "Forget Me Not" text
 * - NO white box or pill shape - completely clean
 */

// Soft pastel forget-me-not flower icon (transparent background)
const FLOWER_ICON_URL = "https://static.prod-images.emergentagent.com/jobs/1a8f8512-5ee0-46d4-a250-4397842b8d6c/images/9d27605f4a072e3d4b36ac22624964b02b7f72a9aaa35a95eff207cf7085f4de.png";

// Legacy logo URL (keeping for reference)
const APP_LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/7dba6171-c1e9-41d2-85ae-e57215f28643/images/2545c5ad180f5f367b2e7d37c25a778abecbd8c7d62f56b3adb1ccc7e3a2d49e.png";

/**
 * AppLogo - Clean brand header, NO background box
 */
const AppLogo = ({ className = "", size = "default", showText = true }) => {
  // Size variants - adjusted text to be 20% smaller
  const sizes = {
    small: { icon: 28, text: 'text-sm' },
    default: { icon: 36, text: 'text-base' },
    large: { icon: 44, text: 'text-lg' },
    xlarge: { icon: 56, text: 'text-xl' },  // Reduced from 72/3xl
  };
  
  const { icon: iconSize, text: textSize } = sizes[size] || sizes.default;
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Flower Icon - NO background, NO box */}
      <img 
        src={FLOWER_ICON_URL} 
        alt=""
        style={{ 
          width: `${iconSize}px`, 
          height: `${iconSize}px`,
        }}
        className="object-contain"
      />
    </div>
  );
};

/**
 * AppLogoCompact - Just the flower icon
 */
export const AppLogoCompact = ({ size = 32, className = "" }) => {
  return (
    <img 
      src={FLOWER_ICON_URL} 
      alt=""
      style={{ 
        width: `${size}px`, 
        height: `${size}px`,
      }}
      className={`object-contain ${className}`}
    />
  );
};

export { APP_LOGO_URL, FLOWER_ICON_URL };
export default AppLogo;
